<template>
  <Modal
    v-model="_value"
    width="500"
    title="锐明设置报警触发条件"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Tabs value="Checkbox" type="card">
      <TabPane label="选择通道" name="Checkbox">
        <Form ref="setDriverParamsRef" v-model="setDriverParams" :label-width="90">
          <FormItem prop="possword" label="密码">
            <Button type="primary" @click="possworsOne" style="margin-right: 5px;">密码1</Button>
            <Button type="primary" @click="posswordTwo">密码2</Button>
            <Input v-model="setDriverParams.possword" type="password" password placeholder="请输入密码">
            </Input>
          </FormItem>

          <FormItem label="通道">
            <CheckboxGroup v-model="setDriverParams.Checkbox">
              <Checkbox label="0">司机疲劳</Checkbox>
              <Checkbox label="1">无驾驶员</Checkbox>
              <Checkbox label="2">驾驶员接打电话</Checkbox>
              <Checkbox label="3">驾驶员抽烟</Checkbox>
              <Checkbox label="4">驾驶员分心</Checkbox>
              <Checkbox label="5">车道偏离</Checkbox>
              <Checkbox label="6">前车碰撞</Checkbox>
              <Checkbox label="9">车距过近</Checkbox>
              <Checkbox label="10">打哈欠</Checkbox>
              <Checkbox label="15">玩手机</Checkbox>
              <Checkbox label="16">未系安全带</Checkbox>
              <Checkbox label="18">盲区检测（右侧）</Checkbox>
              <Checkbox label="20">双手离开方向盘</Checkbox>
              <Checkbox label="21">单手离开方向盘</Checkbox>
            </CheckboxGroup>
          </FormItem>

<!--          <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>-->
<!--          <Button type="primary" @click="onSendDriverCardParams">发送</Button>-->
        </Form>
      </TabPane>

      <template v-for="(item, index) in setDriverParams.Checkbox">

      <TabPane :index="index" v-if="item == 0"  label="司机疲劳" name="access0" style="height: 300px;">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.DSMA[0]" :label-width="90">

          <FormItem prop="EN">
            <Checkbox v-model="setDriverParams.DSMA[0].EN">使能</Checkbox>
          </FormItem>
          <FormItem label="一级报警车速范围">
            <Input v-model="setDriverParams.DSMA[0].FGMS" placeholder="最低值" style="width: 60px;">
            </Input>
            ~
            <Input v-model="setDriverParams.DSMA[0].SGMS" placeholder="最高值" style="width: 60px;">
            </Input>
            千米/小时
          </FormItem>
<!--          <FormItem prop="ESST" label="灵敏度">-->
<!--            <Select v-model="setDriverParams.DSMA[0].ESST" style="width: 90px;margin-right: 5px;">-->
<!--              <Option v-for="item in ESSTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>-->
<!--             </Select>-->
<!--            <div v-if="setDriverParams.DSMA[0].ESST == 4" >-->
<!--            <Input v-model="setDriverParams.DSMA[0].UDT" placeholder="报警时间" style="width: 80px;">-->
<!--            </Input>（0-60）秒-->
<!--            </div>-->
<!--          </FormItem>-->
<!--          <FormItem prop="SDT" label="报警有效时间">-->
<!--            <Input v-model="setDriverParams.DSMA[0].SDT" placeholder="报警有效时间" style="width: 110px;margin-right: 5px;">-->
<!--            </Input>-->
<!--            <Select v-model="setDriverParams.DSMA[0].DTUN" style="width: 90px;">-->
<!--              <Option v-for="item in DTUNOptions" :value="item.value" :key="item.value">{{item.label}}</Option>-->
<!--            </Select>-->
<!--          </FormItem>-->

        </Form>
      </TabPane>

      <TabPane :index="index" v-if="item == 1" label="无驾驶员" name="access1" style="height: 300px;">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.DSMA[1]" :label-width="90">

          <FormItem prop="EN">
            <Checkbox v-model="setDriverParams.DSMA[1].EN">使能</Checkbox>
          </FormItem>
          <FormItem label="一级报警车速范围">
            <Input v-model="setDriverParams.DSMA[1].FGMS" placeholder="最低值" style="width: 60px;">
            </Input>
            ~
            <Input v-model="setDriverParams.DSMA[1].SGMS" placeholder="最高值" style="width: 60px;">
            </Input>
            千米/小时
          </FormItem>
          <FormItem prop="ESST" label="灵敏度">
            <Select v-model="setDriverParams.DSMA[1].ESST" style="width: 90px;margin-right: 5px;">
              <Option v-for="item in ESSTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
            <div v-if="setDriverParams.DSMA[1].ESST == 4" >
              <Input v-model="setDriverParams.DSMA[1].UDT" placeholder="报警时间" style="width: 80px;">
              </Input>（0-60）秒
            </div>
          </FormItem>
          <FormItem prop="SDT" label="报警有效时间">
            <Input v-model="setDriverParams.DSMA[1].SDT" placeholder="报警有效时间" style="width: 110px;margin-right: 5px;">
            </Input>
            <Select v-model="setDriverParams.DSMA[1].DTUN" style="width: 90px;">
              <Option v-for="item in DTUNOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

        </Form>
      </TabPane>

      <TabPane :index="index" v-if="item == 2" label="驾驶员接打电话" name="access2" style="height: 300px;">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.DSMA[2]" :label-width="90">

          <FormItem prop="EN">
            <Checkbox v-model="setDriverParams.DSMA[2].EN">使能</Checkbox>
          </FormItem>
          <FormItem label="一级报警车速范围">
            <Input v-model="setDriverParams.DSMA[2].FGMS" placeholder="最低值" style="width: 60px;">
            </Input>
            ~
            <Input v-model="setDriverParams.DSMA[2].SGMS" placeholder="最高值" style="width: 60px;">
            </Input>
            千米/小时
          </FormItem>
          <FormItem prop="ESST" label="灵敏度">
            <Select v-model="setDriverParams.DSMA[2].ESST" style="width: 90px;margin-right: 5px;">
              <Option v-for="item in ESSTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
            <div v-if="setDriverParams.DSMA[2].ESST == 4" >
              <Input v-model="setDriverParams.DSMA[2].UDT" placeholder="报警时间" style="width: 80px;">
              </Input>（0-60）秒
            </div>
          </FormItem>
          <FormItem prop="SDT" label="报警有效时间">
            <Input v-model="setDriverParams.DSMA[2].SDT" placeholder="报警有效时间" style="width: 110px;margin-right: 5px;">
            </Input>
            <Select v-model="setDriverParams.DSMA[2].DTUN" style="width: 90px;">
              <Option v-for="item in DTUNOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

        </Form>
      </TabPane>

      <TabPane :index="index" v-if="item == 3" label="驾驶员抽烟" name="access3" style="height: 300px;">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.DSMA[3]" :label-width="90">

          <FormItem prop="EN">
            <Checkbox v-model="setDriverParams.DSMA[3].EN">使能</Checkbox>
          </FormItem>
          <FormItem label="一级报警车速范围">
            <Input v-model="setDriverParams.DSMA[3].FGMS" placeholder="最低值" style="width: 60px;">
            </Input>
            ~
            <Input v-model="setDriverParams.DSMA[3].SGMS" placeholder="最高值" style="width: 60px;">
            </Input>
            千米/小时
          </FormItem>
          <FormItem prop="ESST" label="灵敏度">
            <Select v-model="setDriverParams.DSMA[3].ESST" style="width: 90px;margin-right: 5px;">
              <Option v-for="item in ESSTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
            <div v-if="setDriverParams.DSMA[3].ESST == 4" >
              <Input v-model="setDriverParams.DSMA[3].UDT" placeholder="报警时间" style="width: 80px;">
              </Input>（0-60）秒
            </div>
          </FormItem>
          <FormItem prop="SDT" label="报警有效时间">
            <Input v-model="setDriverParams.DSMA[3].SDT" placeholder="报警有效时间" style="width: 110px;margin-right: 5px;">
            </Input>
            <Select v-model="setDriverParams.DSMA[3].DTUN" style="width: 90px;">
              <Option v-for="item in DTUNOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

        </Form>
      </TabPane>

      <TabPane :index="index" v-if="item == 4" label="驾驶员分心" name="access4" style="height: 300px;">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.DSMA[4]" :label-width="90">

          <FormItem prop="EN">
            <Checkbox v-model="setDriverParams.DSMA[4].EN">使能</Checkbox>
          </FormItem>
          <FormItem label="一级报警车速范围">
            <Input v-model="setDriverParams.DSMA[4].FGMS" placeholder="最低值" style="width: 60px;">
            </Input>
            ~
            <Input v-model="setDriverParams.DSMA[4].SGMS" placeholder="最高值" style="width: 60px;">
            </Input>
            千米/小时
          </FormItem>
          <FormItem prop="ESST" label="判断条件">
            <Select v-model="setDriverParams.DSMA[4].SPONE" style="width: 120px;margin-right: 5px;">
              <Option v-for="item in SPONEOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>
          <FormItem prop="ESST" label="灵敏度">
            <Select v-model="setDriverParams.DSMA[4].ESST" style="width: 90px;margin-right: 5px;">
              <Option v-for="item in ESSTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
            <div v-if="setDriverParams.DSMA[4].ESST == 4" >
              <Input v-model="setDriverParams.DSMA[4].UDT" placeholder="报警时间" style="width: 80px;">
              </Input>（0-60）秒
            </div>
          </FormItem>
          <FormItem prop="SDT" label="报警有效时间">
            <Input v-model="setDriverParams.DSMA[4].SDT" placeholder="报警有效时间" style="width: 110px;margin-right: 5px;">
            </Input>
            <Select v-model="setDriverParams.DSMA[4].DTUN" style="width: 90px;">
              <Option v-for="item in DTUNOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

        </Form>
      </TabPane>

      <TabPane :index="index" v-if="item == 5" label="车道偏离" name="access5" style="height: 300px;">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.DSMA[5]" :label-width="90">

          <FormItem prop="EN">
            <Checkbox v-model="setDriverParams.DSMA[5].EN">使能</Checkbox>
          </FormItem>
          <FormItem label="一级报警车速范围">
            <Input v-model="setDriverParams.DSMA[5].FGMS" placeholder="最低值" style="width: 60px;">
            </Input>
            ~
            <Input v-model="setDriverParams.DSMA[5].SGMS" placeholder="最高值" style="width: 60px;">
            </Input>
            千米/小时
          </FormItem>
          <FormItem prop="ESST" label="灵敏度">
            <Select v-model="setDriverParams.DSMA[5].ESST" style="width: 90px;margin-right: 5px;">
              <Option v-for="item in ESSTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
            <div v-if="setDriverParams.DSMA[5].ESST == 4" >
              <Input v-model="setDriverParams.DSMA[5].UDT" placeholder="报警时间" style="width: 80px;">
              </Input>（0-60）秒
            </div>
          </FormItem>
          <FormItem prop="SDT" label="报警有效时间">
            <Input v-model="setDriverParams.DSMA[5].SDT" placeholder="报警有效时间" style="width: 110px;margin-right: 5px;">
            </Input>
            <Select v-model="setDriverParams.DSMA[5].DTUN" style="width: 90px;">
              <Option v-for="item in DTUNOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

        </Form>
      </TabPane>

      <TabPane :index="index" v-if="item == 6" label="前车碰撞" name="access6" style="height: 300px;">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.DSMA[6]" :label-width="90">

          <FormItem prop="EN">
            <Checkbox v-model="setDriverParams.DSMA[6].EN">使能</Checkbox>
          </FormItem>
          <FormItem label="一级报警车速范围">
            <Input v-model="setDriverParams.DSMA[6].FGMS" placeholder="最低值" style="width: 60px;">
            </Input>
            ~
            <Input v-model="setDriverParams.DSMA[6].SGMS" placeholder="最高值" style="width: 60px;">
            </Input>
            千米/小时
          </FormItem>
<!--          <FormItem prop="ESST" label="灵敏度">-->
<!--            <Select v-model="setDriverParams.DSMA[6].ESST" style="width: 90px;margin-right: 5px;">-->
<!--              <Option v-for="item in ESSTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>-->
<!--            </Select>-->
<!--            <div v-if="setDriverParams.DSMA[6].ESST == 4" >-->
<!--              <Input v-model="setDriverParams.DSMA[6].UDT" placeholder="报警时间" style="width: 80px;">-->
<!--              </Input>（0-60）秒-->
<!--            </div>-->
<!--          </FormItem>-->
          <FormItem prop="SDT" label="报警有效时间">
            <Input v-model="setDriverParams.DSMA[6].SDT" placeholder="报警有效时间" style="width: 110px;margin-right: 5px;">
            </Input>
            <Select v-model="setDriverParams.DSMA[6].DTUN" style="width: 90px;">
              <Option v-for="item in DTUNOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

        </Form>
      </TabPane>

      <TabPane :index="index" v-if="item == 9" label="车距过近" name="access9" style="height: 330px;">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.DSMA[9]" :label-width="90">

          <FormItem prop="EN">
            <Checkbox v-model="setDriverParams.DSMA[9].EN">使能</Checkbox>
          </FormItem>
          <FormItem label="一级报警车速范围">
            <Input v-model="setDriverParams.DSMA[9].FGMS" placeholder="最低值" style="width: 60px;">
            </Input>
            ~
            <Input v-model="setDriverParams.DSMA[9].SGMS" placeholder="最高值" style="width: 60px;">
            </Input>
            千米/小时
          </FormItem>
          <FormItem prop="ESST" label="灵敏度">
            <Select v-model="setDriverParams.DSMA[9].ESST" style="width: 90px;margin-right: 5px;">
              <Option v-for="item in ESSTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
            <div v-if="setDriverParams.DSMA[9].ESST == 4" >
              <Input v-model="setDriverParams.DSMA[9].UDT" placeholder="报警时间" style="width: 80px;">
              </Input>（0-60）秒
            </div>
          </FormItem>
          <FormItem prop="SDT" label="报警有效时间">
            <Input v-model="setDriverParams.DSMA[9].SDT" placeholder="报警有效时间" style="width: 110px;margin-right: 5px;">
            </Input>
            <Select v-model="setDriverParams.DSMA[9].DTUN" style="width: 90px;">
              <Option v-for="item in DTUNOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>
          <FormItem prop="VT" label="持续时间">
            <Input v-model="setDriverParams.DSMA[9].VT" placeholder="持续时间" style="width: 110px;margin-right: 5px;">
            </Input>（0-600）秒
          </FormItem>

        </Form>
      </TabPane>

      <TabPane :index="index" v-if="item == 10" label="打哈欠" name="access10" style="height: 300px;">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.DSMA[10]" :label-width="90">

          <FormItem prop="EN">
            <Checkbox v-model="setDriverParams.DSMA[10].EN">使能</Checkbox>
          </FormItem>
          <FormItem label="一级报警车速范围">
            <Input v-model="setDriverParams.DSMA[10].FGMS" placeholder="最低值" style="width: 60px;">
            </Input>
            ~
            <Input v-model="setDriverParams.DSMA[10].SGMS" placeholder="最高值" style="width: 60px;">
            </Input>
            千米/小时
          </FormItem>
          <FormItem prop="ESST" label="灵敏度">
            <Select v-model="setDriverParams.DSMA[10].ESST" style="width: 90px;margin-right: 5px;">
              <Option v-for="item in ESSTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
            <div v-if="setDriverParams.DSMA[10].ESST == 4" >
              <Input v-model="setDriverParams.DSMA[10].UDT" placeholder="报警时间" style="width: 80px;">
              </Input>（0-60）秒
            </div>
          </FormItem>
          <FormItem prop="SDT" label="报警有效时间">
            <Input v-model="setDriverParams.DSMA[10].SDT" placeholder="报警有效时间" style="width: 110px;margin-right: 5px;">
            </Input>
            <Select v-model="setDriverParams.DSMA[10].DTUN" style="width: 90px;">
              <Option v-for="item in DTUNOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

        </Form>
      </TabPane>

      <TabPane :index="index" v-if="item == 14" label="实线变道" name="access14" style="height: 300px;">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.DSMA[14]" :label-width="90">

          <FormItem prop="EN">
            <Checkbox v-model="setDriverParams.DSMA[14].EN">使能</Checkbox>
          </FormItem>
          <FormItem label="一级报警车速范围">
            <Input v-model="setDriverParams.DSMA[14].FGMS" placeholder="最低值" style="width: 60px;">
            </Input>
            ~
            <Input v-model="setDriverParams.DSMA[14].SGMS" placeholder="最高值" style="width: 60px;">
            </Input>
            千米/小时
          </FormItem>
          <FormItem prop="ESST" label="灵敏度">
            <Select v-model="setDriverParams.DSMA[14].ESST" style="width: 90px;margin-right: 5px;">
              <Option v-for="item in ESSTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
            <div v-if="setDriverParams.DSMA[14].ESST == 4" >
              <Input v-model="setDriverParams.DSMA[14].UDT" placeholder="报警时间" style="width: 80px;">
              </Input>（0-60）秒
            </div>
          </FormItem>
          <FormItem prop="SDT" label="报警有效时间">
            <Input v-model="setDriverParams.DSMA[14].SDT" placeholder="报警有效时间" style="width: 110px;margin-right: 5px;">
            </Input>
            <Select v-model="setDriverParams.DSMA[14].DTUN" style="width: 90px;">
              <Option v-for="item in DTUNOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

        </Form>
      </TabPane>

      <TabPane :index="index" v-if="item == 15" label="玩手机" name="access15" style="height: 300px;">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.DSMA[15]" :label-width="90">

          <FormItem prop="EN">
            <Checkbox v-model="setDriverParams.DSMA[15].EN">使能</Checkbox>
          </FormItem>
          <FormItem label="一级报警车速范围">
            <Input v-model="setDriverParams.DSMA[15].FGMS" placeholder="最低值" style="width: 60px;">
            </Input>
            ~
            <Input v-model="setDriverParams.DSMA[15].SGMS" placeholder="最高值" style="width: 60px;">
            </Input>
            千米/小时
          </FormItem>
          <FormItem prop="ESST" label="灵敏度">
            <Select v-model="setDriverParams.DSMA[15].ESST" style="width: 90px;margin-right: 5px;">
              <Option v-for="item in ESSTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
            <div v-if="setDriverParams.DSMA[15].ESST == 4" >
              <Input v-model="setDriverParams.DSMA[15].UDT" placeholder="报警时间" style="width: 80px;">
              </Input>（0-60）秒
            </div>
          </FormItem>
          <FormItem prop="SDT" label="报警有效时间">
            <Input v-model="setDriverParams.DSMA[15].SDT" placeholder="报警有效时间" style="width: 110px;margin-right: 5px;">
            </Input>
            <Select v-model="setDriverParams.DSMA[15].DTUN" style="width: 90px;">
              <Option v-for="item in DTUNOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

        </Form>
      </TabPane>

      <TabPane :index="index" v-if="item == 16" label="未系安全带" name="access16" style="height: 300px;">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.DSMA[16]" :label-width="90">

          <FormItem prop="EN">
            <Checkbox v-model="setDriverParams.DSMA[16].EN">使能</Checkbox>
          </FormItem>
          <FormItem label="一级报警车速范围">
            <Input v-model="setDriverParams.DSMA[16].FGMS" placeholder="最低值" style="width: 60px;">
            </Input>
            ~
            <Input v-model="setDriverParams.DSMA[16].SGMS" placeholder="最高值" style="width: 60px;">
            </Input>
            千米/小时
          </FormItem>
          <FormItem prop="ESST" label="灵敏度">
            <Select v-model="setDriverParams.DSMA[16].ESST" style="width: 90px;margin-right: 5px;">
              <Option v-for="item in ESSTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
            <div v-if="setDriverParams.DSMA[16].ESST == 4" >
              <Input v-model="setDriverParams.DSMA[16].UDT" placeholder="报警时间" style="width: 80px;">
              </Input>（0-60）秒
            </div>
          </FormItem>
          <FormItem prop="SDT" label="报警有效时间">
            <Input v-model="setDriverParams.DSMA[16].SDT" placeholder="报警有效时间" style="width: 110px;margin-right: 5px;">
            </Input>
            <Select v-model="setDriverParams.DSMA[16].DTUN" style="width: 90px;">
              <Option v-for="item in DTUNOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

        </Form>
      </TabPane>

      <TabPane :index="index" v-if="item == 18" label="盲区检测（右侧）" name="access18" style="height: 400px;">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.DSMA[18]" :label-width="90">

          <FormItem prop="EN">
            <Checkbox v-model="setDriverParams.DSMA[18].EN">使能</Checkbox>
          </FormItem>
          <FormItem label="报警车速范围">
            <Input v-model="setDriverParams.DSMA[18].FGMS" placeholder="最低值" style="width: 60px;">
            </Input>
            ~
            <Input v-model="setDriverParams.DSMA[18].SGMS" placeholder="最高值" style="width: 60px;">
            </Input>
            千米/小时
          </FormItem>
          <FormItem prop="VT" label="持续时间">
            <Input v-model="setDriverParams.DSMA[9].VT" placeholder="持续时间" style="width: 110px;margin-right: 5px;">
            </Input>（0-600）秒
          </FormItem>
          <FormItem prop="SDT" label="报警有效时间">
            <Input v-model="setDriverParams.DSMA[18].SDT" placeholder="报警有效时间" style="width: 110px;margin-right: 5px;">
            </Input>
            <Select v-model="setDriverParams.DSMA[18].DTUN" style="width: 90px;">
              <Option v-for="item in DTUNOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>
          <FormItem prop="SPONE" label="直行报警距离范围">
            <Input v-model="setDriverParams.DSMA[18].SPONE" placeholder="直行报警距离范围" style="width: 110px;margin-right: 5px;">
            </Input>厘米
          </FormItem>
          <FormItem prop="SPTWO" label="转弯报警距离范围">
            <Input v-model="setDriverParams.DSMA[18].SPTWO" placeholder="转弯报警距离范围" style="width: 110px;margin-right: 5px;">
            </Input>厘米
          </FormItem>
          <FormItem prop="SUBEN">
            <Checkbox v-model="setDriverParams.DSMA[18].SUBEN">需要打开右转向灯</Checkbox>
          </FormItem>
<!--          <FormItem prop="ESST" label="灵敏度">-->
<!--            <Select v-model="setDriverParams.DSMA[18].ESST" style="width: 90px;margin-right: 5px;">-->
<!--              <Option v-for="item in ESSTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>-->
<!--            </Select>-->
<!--            <div v-if="setDriverParams.DSMA[18].ESST == 4" >-->
<!--              <Input v-model="setDriverParams.DSMA[18].UDT" placeholder="报警时间" style="width: 80px;">-->
<!--              </Input>（0-60）秒-->
<!--            </div>-->
<!--          </FormItem>-->

        </Form>
      </TabPane>

      <TabPane :index="index" v-if="item == 20" label="双手离开方向盘" name="access20" style="height: 300px;">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.DSMA[20]" :label-width="90">

          <FormItem prop="EN">
            <Checkbox v-model="setDriverParams.DSMA[20].EN">使能</Checkbox>
          </FormItem>
          <FormItem label="一级报警车速范围">
            <Input v-model="setDriverParams.DSMA[20].FGMS" placeholder="最低值" style="width: 60px;">
            </Input>
            ~
            <Input v-model="setDriverParams.DSMA[20].SGMS" placeholder="最高值" style="width: 60px;">
            </Input>
            千米/小时
          </FormItem>
          <FormItem prop="ESST" label="灵敏度">
            <Select v-model="setDriverParams.DSMA[20].ESST" style="width: 90px;margin-right: 5px;">
              <Option v-for="item in ESSTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
            <div v-if="setDriverParams.DSMA[20].ESST == 4" >
              <Input v-model="setDriverParams.DSMA[20].UDT" placeholder="报警时间" style="width: 80px;">
              </Input>（0-60）秒
            </div>
          </FormItem>
          <FormItem prop="SDT" label="报警有效时间">
            <Input v-model="setDriverParams.DSMA[20].SDT" placeholder="报警有效时间" style="width: 110px;margin-right: 5px;">
            </Input>
            <Select v-model="setDriverParams.DSMA[20].DTUN" style="width: 90px;">
              <Option v-for="item in DTUNOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

        </Form>
      </TabPane>

      <TabPane :index="index" v-if="item == 21" label="单手离开方向盘" name="access21" style="height: 300px;">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.DSMA[21]" :label-width="90">

          <FormItem prop="EN">
            <Checkbox v-model="setDriverParams.DSMA[21].EN">使能</Checkbox>
          </FormItem>
          <FormItem label="一级报警车速范围">
            <Input v-model="setDriverParams.DSMA[21].FGMS" placeholder="最低值" style="width: 60px;">
            </Input>
            ~
            <Input v-model="setDriverParams.DSMA[21].SGMS" placeholder="最高值" style="width: 60px;">
            </Input>
            千米/小时
          </FormItem>
          <FormItem prop="ESST" label="灵敏度">
            <Select v-model="setDriverParams.DSMA[21].ESST" style="width: 90px;margin-right: 5px;">
              <Option v-for="item in ESSTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
            <div v-if="setDriverParams.DSMA[21].ESST == 4" >
              <Input v-model="setDriverParams.DSMA[21].UDT" placeholder="报警时间" style="width: 80px;">
              </Input>（0-60）秒
            </div>
          </FormItem>
          <FormItem prop="SDT" label="报警有效时间">
            <Input v-model="setDriverParams.DSMA[21].SDT" placeholder="报警有效时间" style="width: 110px;margin-right: 5px;">
            </Input>
            <Select v-model="setDriverParams.DSMA[21].DTUN" style="width: 90px;">
              <Option v-for="item in DTUNOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

        </Form>
      </TabPane>

      </template>

    </Tabs>
    <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
    <Button type="primary" @click="onSendDriverCardParams">发送</Button>
  </Modal>
</template>

<script>

  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import store from '@/store'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

  export default {
    name: 'rmsetdriveralarmconditionmodal',
    components: {

    },
    props: {
      initValue: null,
      terminalNumValue: null,
      value: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        setDriverParams: {
          id: null,
          possword: 'admin',
          Checkbox:[],
      //     参数：
      // EN->启用  1：启用  0：关闭
      // FGMS->一级报警车速范围低值
      // SGMS->一级报警车速范围高值
      // ESST->灵敏度  1：低   2：中  3：高  4：自定义
      // UDT->灵敏度自定义时的触发报警时间
      // SDT->报警有效时间
      // DTUN->报警有效时间单位     0：秒  1：分钟
      // SPONE->仅报警为司机分心时有次设置项设置判断条件     0：上下+左右看  1：左右看  2：上下看
          DSMA:[
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:10,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:10,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:10,DTUN:1,SPONE:0},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null,VT:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:10,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:10,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null,SPTWO:null,SUBEN:false},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:10,DTUN:1,SPONE:null},
            {EN:true,FGMS:20,SGMS:50,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          ]
        },

        JSON:['null','null','null','null','null','null','null','null','null','null','null','null','null','null','null','null','null','null','null','null','null'],

        ESSTOptions: [
          {label: '低', value: 1},
          {label: '中', value: 2},
          {label: '高', value: 3},
          {label: '自定义', value: 4},
        ],

        DTUNOptions: [
          {label: '秒', value: 0},
          {label: '分钟', value: 1},
        ],

        SPONEOptions: [
          {label: '上下+左右看', value: 0},
          {label: '左右看', value: 1},
          {label: '上下看', value: 2},
        ],

      }
    },
    methods: {
      ...mapActions([
        'VehicleInfoServ_SearchByName'
      ]),
      visibleChange (val) {
        if (val) {
          this.setDriverParams.id = this._initValue
          this.possworsOne()
        }
      },
      onCleanDriverCardParams () {
        this.setDriverParams.possword = 'admin'
        this.setDriverParams.Checkbox = []
        this.setDriverParams.DSMA = [
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null,VT:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null,SPTWO:null,SUBEN:false},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
          {EN:true,FGMS:null,SGMS:null,ESST:1,UDT:null,SDT:null,DTUN:1,SPONE:null},
        ]
      },
      SendCommand(content){
        store.dispatch('NetCommandServ_SendCommand', {
          params: { id: this._initValue, content:content, urgent: false }
        }).then(() => {
          this.$Message.success('发送成功')
          this.JSON = ['null','null','null','null','null','null']
        }).catch(err => {
          this.$Message.error(err)
          this.JSON = ['null','null','null','null','null','null']
        })
      },
      onSendDriverCardParams () {

        console.log(this.setDriverParams)
        for (let i = 0; i < this.setDriverParams.Checkbox.length; i++) {
        console.log(this.JSON)
        console.log(this.setDriverParams.Checkbox[i])
        console.log(this.setDriverParams.DSMA[this.setDriverParams.Checkbox[i]])
        console.log(JSON.stringify(this.JSON[this.setDriverParams.Checkbox[i]]))
          if (this.setDriverParams.DSMA[this.setDriverParams.Checkbox[i]].EN) {
            this.setDriverParams.DSMA[this.setDriverParams.Checkbox[i]].EN = 1
          }else {
            this.setDriverParams.DSMA[this.setDriverParams.Checkbox[i]].EN = 0
          }
          if (this.setDriverParams.Checkbox[i] == 18){
            if (this.setDriverParams.DSMA[this.setDriverParams.Checkbox[i]].SUBEN) {
              this.setDriverParams.DSMA[this.setDriverParams.Checkbox[i]].SUBEN = 1
            }else {
              this.setDriverParams.DSMA[this.setDriverParams.Checkbox[i]].SUBEN = 0
            }
          }
          this.JSON[this.setDriverParams.Checkbox[i]] = JSON.stringify(this.setDriverParams.DSMA[this.setDriverParams.Checkbox[i]])
        console.log(this.JSON[this.setDriverParams.Checkbox[i]])
        }

        this.SendCommand('99admin,admin,JSON,{"DSM":{"DSMA":[' + this.JSON + ']}}!')

        setTimeout(() => {
            this.SendCommand('99admin,JC336699,JSON,{"DSM":{"DSMA":[' + this.JSON + ']}}!')
          }
          ,1000)

        setTimeout(() => {
            this.SendCommand('99admin,,JSON,{"DSM":{"DSMA":[' + this.JSON + ']}}!')
          }
          ,2000)

        setTimeout(() => {
            this.SendCommand('99admin,870315,JSON,{"DSM":{"DSMA":[' + this.JSON + ']}}!')
          }
          ,3000)

        setTimeout(() => {
            this.SendCommand('99admin,JcBOZSJCB0,JSON,{"DSM":{"DSMA":[' + this.JSON + ']}}!')
          }
          ,4000)

        // console.log('99admin,' + this.setDriverParams.possword + ',JSON,{"DSM":{"DSMA":[' + this.JSON + ']}}!')
        // let content = '99admin,' + this.setDriverParams.possword + ',JSON,{"DSM":{"DSMA":[' + this.JSON + ']}}!'
        // store.dispatch('NetCommandServ_SendCommand', {
        //   params: { id: this._initValue, content:content, urgent: false }
        // }).then(() => {
        //   this.$Message.success('发送成功')
        //   this.JSON = ['null','null','null','null','null','null']
        // }).catch(err => {
        //   this.$Message.error(err)
        //   this.JSON = ['null','null','null','null','null','null']
        // })
      },
      possworsOne(){
        this.setDriverParams.possword = 'admin'
      },
      posswordTwo(){
        this.setDriverParams.possword = 'JC336699'
      },
    },
    computed: {
      _value: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get () {
          return this.initValue
        },
        set (val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _terminalNumValue: {
        get () {
          return this.terminalNumValue
        },
        set (val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted () {
      this.$nextTick(() => {

      })
    }
  }
</script>
